import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DropdownOption } from '~/component/form/dropdown/interfaces/option.interface';

@Component({
  selector: 'app-form-dropdown-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class FormDropdownListComponent {
  @Input() public isOpen = false;
  @Input() public options: DropdownOption[] = [];
  @Input() public triggerId: string;

  @Output() public readonly selectOption = new EventEmitter();

  public setSelected(option: DropdownOption): void {
    this.selectOption.emit(option);
  }
}
